import { KnowledgeList } from '../features/knowledge';

export default function KnowledgePage() {
  return (
    <div className="mx-auto max-w-6xl p-6">
      <KnowledgeList />
    </div>
  );
}
